'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import MissionSection from './MissionSection';
import TeamSection from './TeamSection';
import TimelineSection from './TimelineSection';
import PartnershipsSection from './PartnershipsSection';
import AwardsSection from './AwardsSection';
import ValuesSection from './ValuesSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';

import ContactSection from './ContactSection';

export default function AboutContent() {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return (
            <div className="min-h-screen bg-background pt-16">
                <div className="animate-pulse space-y-8 p-8">
                    <div className="h-96 bg-surface rounded-lg" />
                    <div className="h-64 bg-surface rounded-lg" />
                    <div className="h-64 bg-surface rounded-lg" />
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-background">
            <HeroSection />
            <MissionSection />
            <ValuesSection />
            <TeamSection />
            {/* <TimelineSection /> */}
            <PartnershipsSection />
            {/* <AwardsSection /> */}
            {/* <TestimonialsSection /> */}
            <ContactSection />
            <CTASection />
        </div>
    );
}